/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetZReport200ResponseShiftsValue } from './GetZReport200ResponseShiftsValue';
import {
    GetZReport200ResponseShiftsValueFromJSON,
    GetZReport200ResponseShiftsValueFromJSONTyped,
    GetZReport200ResponseShiftsValueToJSON,
    GetZReport200ResponseShiftsValueToJSONTyped,
} from './GetZReport200ResponseShiftsValue';
import type { GetZReport200ResponseBreakdown } from './GetZReport200ResponseBreakdown';
import {
    GetZReport200ResponseBreakdownFromJSON,
    GetZReport200ResponseBreakdownFromJSONTyped,
    GetZReport200ResponseBreakdownToJSON,
    GetZReport200ResponseBreakdownToJSONTyped,
} from './GetZReport200ResponseBreakdown';
import type { GetZReport200ResponseStats } from './GetZReport200ResponseStats';
import {
    GetZReport200ResponseStatsFromJSON,
    GetZReport200ResponseStatsFromJSONTyped,
    GetZReport200ResponseStatsToJSON,
    GetZReport200ResponseStatsToJSONTyped,
} from './GetZReport200ResponseStats';
import type { GetZReport200ResponseMoneyEarned } from './GetZReport200ResponseMoneyEarned';
import {
    GetZReport200ResponseMoneyEarnedFromJSON,
    GetZReport200ResponseMoneyEarnedFromJSONTyped,
    GetZReport200ResponseMoneyEarnedToJSON,
    GetZReport200ResponseMoneyEarnedToJSONTyped,
} from './GetZReport200ResponseMoneyEarned';

/**
 * 
 * @export
 * @interface GetZReport200Response
 */
export interface GetZReport200Response {
    /**
     * 
     * @type {string}
     * @memberof GetZReport200Response
     */
    firstBill?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetZReport200Response
     */
    lastBill?: string | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetZReport200Response
     */
    tabsPerSource: { [key: string]: number; };
    /**
     * 
     * @type {GetZReport200ResponseBreakdown}
     * @memberof GetZReport200Response
     */
    breakdown: GetZReport200ResponseBreakdown;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetZReport200Response
     */
    payments: { [key: string]: number; };
    /**
     * 
     * @type {GetZReport200ResponseStats}
     * @memberof GetZReport200Response
     */
    stats: GetZReport200ResponseStats;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetZReport200Response
     */
    tips: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetZReport200Response
     */
    paymentsWithoutTips: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: GetZReport200ResponseShiftsValue; }}
     * @memberof GetZReport200Response
     */
    shifts?: { [key: string]: GetZReport200ResponseShiftsValue; };
    /**
     * 
     * @type {number}
     * @memberof GetZReport200Response
     */
    totalIns: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200Response
     */
    totalOuts: number;
    /**
     * 
     * @type {GetZReport200ResponseMoneyEarned}
     * @memberof GetZReport200Response
     */
    moneyEarned: GetZReport200ResponseMoneyEarned;
    /**
     * 
     * @type {string}
     * @memberof GetZReport200Response
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof GetZReport200Response
     */
    endDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetZReport200Response
     */
    multipleShifts: boolean;
}

/**
 * Check if a given object implements the GetZReport200Response interface.
 */
export function instanceOfGetZReport200Response(value: object): value is GetZReport200Response {
    if (!('tabsPerSource' in value) || value['tabsPerSource'] === undefined) return false;
    if (!('breakdown' in value) || value['breakdown'] === undefined) return false;
    if (!('payments' in value) || value['payments'] === undefined) return false;
    if (!('stats' in value) || value['stats'] === undefined) return false;
    if (!('tips' in value) || value['tips'] === undefined) return false;
    if (!('paymentsWithoutTips' in value) || value['paymentsWithoutTips'] === undefined) return false;
    if (!('totalIns' in value) || value['totalIns'] === undefined) return false;
    if (!('totalOuts' in value) || value['totalOuts'] === undefined) return false;
    if (!('moneyEarned' in value) || value['moneyEarned'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('multipleShifts' in value) || value['multipleShifts'] === undefined) return false;
    return true;
}

export function GetZReport200ResponseFromJSON(json: any): GetZReport200Response {
    return GetZReport200ResponseFromJSONTyped(json, false);
}

export function GetZReport200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReport200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'firstBill': json['firstBill'] == null ? undefined : json['firstBill'],
        'lastBill': json['lastBill'] == null ? undefined : json['lastBill'],
        'tabsPerSource': json['tabsPerSource'],
        'breakdown': GetZReport200ResponseBreakdownFromJSON(json['breakdown']),
        'payments': json['payments'],
        'stats': GetZReport200ResponseStatsFromJSON(json['stats']),
        'tips': json['tips'],
        'paymentsWithoutTips': json['paymentsWithoutTips'],
        'shifts': json['shifts'] == null ? undefined : (mapValues(json['shifts'], GetZReport200ResponseShiftsValueFromJSON)),
        'totalIns': json['totalIns'],
        'totalOuts': json['totalOuts'],
        'moneyEarned': GetZReport200ResponseMoneyEarnedFromJSON(json['moneyEarned']),
        'startDate': json['startDate'],
        'endDate': json['endDate'],
        'multipleShifts': json['multipleShifts'],
    };
}

export function GetZReport200ResponseToJSON(json: any): GetZReport200Response {
    return GetZReport200ResponseToJSONTyped(json, false);
}

export function GetZReport200ResponseToJSONTyped(value?: GetZReport200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstBill': value['firstBill'],
        'lastBill': value['lastBill'],
        'tabsPerSource': value['tabsPerSource'],
        'breakdown': GetZReport200ResponseBreakdownToJSON(value['breakdown']),
        'payments': value['payments'],
        'stats': GetZReport200ResponseStatsToJSON(value['stats']),
        'tips': value['tips'],
        'paymentsWithoutTips': value['paymentsWithoutTips'],
        'shifts': value['shifts'] == null ? undefined : (mapValues(value['shifts'], GetZReport200ResponseShiftsValueToJSON)),
        'totalIns': value['totalIns'],
        'totalOuts': value['totalOuts'],
        'moneyEarned': GetZReport200ResponseMoneyEarnedToJSON(value['moneyEarned']),
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'multipleShifts': value['multipleShifts'],
    };
}

